<h2 mat-dialog-title>Contato com o fornecedor</h2>
<mat-dialog-content class="mat-typography">

  <p>Tem certeza que quer entrar em contato com o fornecedor?</p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Sim</button>
  <button mat-button mat-dialog-close>Não</button>
</mat-dialog-actions>
